import { SidoName } from "../types";

export const FUNERAL_SIDO: Map<number, SidoName> = new Map([
  [11, SidoName.서울],
  [31, SidoName.경기],
  [21, SidoName.부산],
  [22, SidoName.대구],
  [23, SidoName.인천],
  [24, SidoName.광주],
  [25, SidoName.대전],
  [26, SidoName.울산],
  [29, SidoName.세종],
  [32, SidoName.강원],
  [33, SidoName.충북],
  [34, SidoName.충남],
  [35, SidoName.전북],
  [36, SidoName.전남],
  [37, SidoName.경북],
  [38, SidoName.경남],
  [39, SidoName.제주],
]);

export const FUNERAL_SIDO_REVERSE: { [key in SidoName]: number } = {
  서울: 11,
  경기: 31,
  부산: 21,
  대구: 22,
  인천: 23,
  광주: 24,
  대전: 25,
  울산: 26,
  세종: 29,
  강원: 32,
  충북: 33,
  충남: 34,
  전북: 35,
  전남: 36,
  경북: 37,
  경남: 38,
  제주: 39,
};

export const FUNERAL_SIDO_LIST = Array.from(FUNERAL_SIDO);
